module.exports = __webpack_public_path__ + "static/media/IMG_0405.d81ddf82.JPG";